import { Nav } from '@/components/layout/nav'
import { Footer } from '@/components/layout/footer'
import { Hero } from './hero'
import { ProblemSection } from './problem-section'
import { OacSection } from './oac-section'
import { OfferSection } from './offer-section'
import { SolutionSection } from './solution-section'
import { TestimonialsSection } from './testimonials-section'
import { SignupFormSection } from './signup-form-section'

export function LandingPage() {
  return (
    <div className="flex min-h-screen flex-col bg-[#0e1110]">
      <Nav />
      <main className="flex-1">
        <Hero />
        <ProblemSection />
        {/* OAC sits before the paid offer on purpose: it is the proof that
            makes the £150 credible, so it should be read first. */}
        <OacSection />
        <OfferSection />
        <SolutionSection />
        <TestimonialsSection />
        <SignupFormSection />
      </main>
      <Footer />
    </div>
  )
}
